import { Box, Button, Typography, useTheme } from "@mui/material";
import FareharborForm from "app/components/Integrations/FarharborIntegration/FareharborForm";
import MailIcon from "assets/icons/mail_green_icon.svg";
import SendIcon from "assets/icons/send_green_icon.svg";
import { useState } from "react";
import { fareharborStyles } from "styles/IntegrationDirectory/fareharbor.styles";

const FareharborIntegration = () => {
  const theme = useTheme();
  const [step, setstep] = useState<number>(1);

  return (
    <Box fontFamily={theme.typography.fontFamily}>
      {step === 1 ? (
        <Box margin="1rem">
          <Typography sx={fareharborStyles.mainHeading}>
            FareHarbor Import Instructions
          </Typography>

          <Typography sx={[fareharborStyles.mainText, fareharborStyles.mb10]}>
            Follow these steps to integrate your FareHarbor calendar with
            Referee. Once imported, you can set commission rates for each item
            in your Items list.
          </Typography>

          <Box sx={[fareharborStyles.singlePan, fareharborStyles.mb10]}>
            <img src={MailIcon} alt="mail" />
            <Typography sx={fareharborStyles.subHeading} fontWeight={"600"}>
              Email FareHarbor Support
            </Typography>
          </Box>

          <Box sx={fareharborStyles.mb10}>
            <Typography sx={fareharborStyles.smallText}>
              Use the email associated with your FareHarbor account to send the
              following email to api-support@fareharbor.com and
              info@myreferee.com
            </Typography>

            <Typography sx={fareharborStyles.smallHeading}>
              {`\u2022`} Subject:
            </Typography>
            <Typography
              sx={[fareharborStyles.smallText, fareharborStyles.ml10]}
            >
              “Please integrate my FareHarbor calendar with Referee.”
            </Typography>

            <Typography sx={fareharborStyles.smallHeading}>
              {`\u2022`} Email Body:
            </Typography>
            <Typography
              sx={[fareharborStyles.smallText, fareharborStyles.ml10]}
            >
              “I confirm that I want to integrate my FareHarbor calendar with
              Referee. I understand that I can set my commission rate within the
              Referee platform. Our FareHarbor short name is (enter short
              name).”
            </Typography>
          </Box>

          <Box sx={[fareharborStyles.singlePan, fareharborStyles.mb10]}>
            <img src={SendIcon} alt="send" />
            <Typography sx={fareharborStyles.subHeading} fontWeight={"600"}>
              Start Import
            </Typography>
          </Box>

          <Typography sx={[fareharborStyles.smallText, fareharborStyles.mb10]}>
            Once your integration is approved, FareHarbor will send you a
            confirmation email! As soon as you receive it, click “Next” and
            follow the easy steps to complete your calendar import!
          </Typography>

          <Button
            variant="contained"
            sx={fareharborStyles.btnStyle}
            onClick={() => setstep(2)}
          >
            Next
          </Button>
        </Box>
      ) : (
        <FareharborForm />
      )}
    </Box>
  );
};
export default FareharborIntegration;
